'use client';

import { JsBasicAppLoader } from '@repo-ui/code-project/js-basic-app';

export default function Page() {
  return <JsBasicAppLoader />;
}
